import apiHandler from "../core/apiHandler";

const entityTypeApi = apiHandler('entity-types');
export default entityTypeApi;